export default "__VITE_ASSET__DOhTJ0ds__"